// extracted by mini-css-extract-plugin
module.exports = {"disabled":"button_disabled__3iQhl"};